








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SelectOption extends Vue {
  @Prop({ required: true }) value!: any;

  @Prop({ default: false }) selected!: boolean;

  // Optional: Ein Label, falls nicht der Slotinhalt genutzt werden soll
  @Prop({ default: '' })label!: string;
}
